<div class="flex flex-col h-full" *ngIf="media$ | async as media">
  <div class="pt-2 pb-1 fixed top-100 -ml-2 bg-white back-button-div w-95 top-16 max-w-4xl">
    <button (click)="navigateToAppointment()" mat-flat-button color="primary" class="mr-4 back-button">
      <mat-icon class="-ml-2 arr">keyboard_arrow_left</mat-icon>
      Back
    </button>
  </div>
  <div class="flex flex-row place-content-between pr-4 mt-10">
    <h1>Media Gallery</h1>
    <div>
      <button mat-icon-button (click)="clearFilterMedia()" *ngIf="showClearButton$ | async">
        <mat-icon>clear</mat-icon>
      </button>
      <button mat-icon-button cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="isPopoverOpen = !isPopoverOpen"
        class="filter-button">
        <mat-icon>filter_list</mat-icon>
      </button>

      <ng-template cdkConnectedOverlay cdkConnectedOverlayPanelClass="overlay-container"
        cdkConnectedOverlayBackdropClass="none" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="isPopoverOpen" [cdkConnectedOverlayOrigin]="trigger"
        (backdropClick)="isPopoverOpen = false">
        <sha-media-gallery-filter (filtersChanged)="filterMedia($event); isPopoverOpen = false">
        </sha-media-gallery-filter>
      </ng-template>
    </div>
  </div>
  <sha-media-gallery [media]="media"></sha-media-gallery>
</div>
